export default __webpack_public_path__ + "static/media/default-monochrome.eec06268.svg";